export default {
  notoSansKRBold: "NotoSansKR-Bold",
  notoSansKRLight: "NotoSansKR-Light",
  notoSansKRRegular: "NotoSansKR-Regular",
  notoSansKRMedium: "NotoSansKR-Medium",
  spoqa: "'Spoqa Han Sans Neo', 'sans-serif'",
};
